// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-form-question-icon-index.cdk-drag-handle {
  cursor: grab;
}
.fi-form-question-icon-index.cdk-drag-handle:active {
  cursor: grabbing;
}
.fi-form-question-icon-index .form-field-question-index-icon-wrapper {
  text-align: center;
  color: var(--fi-color-light-gray);
}
.fi-form-question-icon-index .form-field-question-index-icon-wrapper .question-icon {
  font-size: 24px;
  margin-bottom: 5px;
  display: block;
  width: unset;
}`, "",{"version":3,"sources":["webpack://./Source/app/fi-form/fi-form-edit/fi-form-edit-form/form-question-icon-index/form-question-icon-index.component.scss"],"names":[],"mappings":"AACI;EACI,YAAA;AAAR;AAEQ;EACI,gBAAA;AAAZ;AAII;EACI,kBAAA;EACA,iCAAA;AAFR;AAIQ;EACI,eAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AAFZ","sourcesContent":[".fi-form-question-icon-index {\r\n    &.cdk-drag-handle {\r\n        cursor: grab;\r\n\r\n        &:active {\r\n            cursor: grabbing;\r\n        }\r\n    }\r\n\r\n    .form-field-question-index-icon-wrapper {\r\n        text-align: center;\r\n        color: var(--fi-color-light-gray);\r\n\r\n        .question-icon {\r\n            font-size: 24px;\r\n            margin-bottom: 5px;\r\n            display: block;\r\n            width: unset;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
